@if (viewType !== undefined) {
  <div (click)="viewType = undefined; isLoading = true;"
       class="fixed right-0 top-0 h-full w-full z-[110] md:top-[20%]  flex flex-col justify-center items-end">
    <div (click)="$event.stopPropagation()"
         class="cursor-default flex mr-[1.25rem] md:mr-[6rem] flex-col justify-center w-[90%] md:w-[500px] bg-white shadow-lg rounded-xl overflow-hidden">
      @if (viewType === 'msaadaAi') {
        <div class="flex justify-between items-center p-2 bg-primary-500 text-white">
          <div class="flex items-center gap-2">
            <img alt="Msaada ai" src="assets/images/hudumaAI.png" class="rounded-full  h-12 w-12"
                 style="--order-25">
            <span class="font-bold text-lg">{{ "Msaada Ai"|concat|translate }}</span>
          </div>
          <div (click)="viewType = undefined; isLoading = true;"
               class="px-1.5 pt-1.5 cursor-pointer hover:bg-red-300/20 rounded-full">
            <mat-icon>clear</mat-icon>
          </div>
        </div>

        <div class="relative">

          <iframe
            src="https://rag.all.tz/chat/share?shared_id=16eca75041c711f0820d0242c0a83006&from=agent&auth=NkNDlmOTA0ZjJhMTExZjA5OThjMDI0Mm&enable_tts=1&locale=sw"
            style="width: 100%; height: 100%;"
            title="msaada ai"
            class="min-h-[80vh] md:min-h-[600px]"
            (load)="isLoading = false"
            allow="microphone https://rag.all.tz; camera https://rag.all.tz;">
          </iframe>

          @if (isLoading) {
            <div class="absolute top-0 h-full w-full flex justify-center items-center">
              <div class="spinner-box">
                <img src="/assets/images/logo_animated.gif"
                     alt="loader"
                     class=""/>
              </div>
            </div>
          }

        </div>

      } @else if (viewType === 'chatCenter') {
        <div class="flex justify-between items-center p-2 bg-primary-500 text-white">
          <div class="flex items-center gap-2">
            <div class="px-2">
              <mat-icon class="chat-center-icon" svgIcon="bot-white"></mat-icon>
            </div>
            <span class="font-bold text-lg">{{ "Chat Center"|concat|translate }}</span>
          </div>
          <div (click)="viewType = undefined; isLoading = true;"
               class="px-1.5 pt-1.5 cursor-pointer hover:bg-red-300/20 rounded-full">
            <mat-icon>clear</mat-icon>
          </div>
        </div>

        <div class="relative">
          <iframe
            src="https://chatcenter.ccds.all.tz/widget?website_token=NfTidb5YzrvHVnw4g9xiHdNK"
            allow="camera;microphone;fullscreen;display-capture;picture-in-picture;clipboard-write;"
            style="width: 100%; height: 100%;"
            class="min-h-[80vh] md:min-h-[600px]"
            (load)="isLoading = false"
            id="chatwoot_live_chat_widget"></iframe>

          @if (isLoading) {
            <div class="absolute top-0 h-full w-full flex justify-center items-center">
              <div class="spinner-box">
                <img src="/assets/images/logo_animated.gif"
                     alt="loader"
                     class=""/>
              </div>
            </div>
          }

        </div>
      } @else {
        <div class="flex justify-between items-center p-2 bg-primary-500 text-white">
          <div class="flex items-center gap-2">
            <div class="px-2">
              <mat-icon class="chat-center-icon" svgIcon="accessibility"></mat-icon>
            </div>
            <span class="font-bold text-lg">{{ "Accessibility"|concat|translate }}</span>
          </div>
          <div (click)="viewType = undefined; isLoading = true;"
               class="px-1.5 pt-1.5 cursor-pointer hover:bg-red-300/20 rounded-full">
            <mat-icon>clear</mat-icon>
          </div>
        </div>
        <app-accessibility></app-accessibility>
      }
    </div>
  </div>
}

<div class="fixed right-0 top-[45%] z-[100] cursor-pointer flex">
  <div class="flex flex-col gap-3 items-end">
    @if (viewType === undefined || viewType === 'accessibility') {
      <div
        class="flex items-center group transition-all duration-500 ease-linear">
        <div
          (click)="viewType = 'accessibility'"
          class="helpUtility tw-relative tw-overflow-visible">
          <mat-icon svgIcon="accessibility"></mat-icon>
          <div class="orbit-container">
            <div class="star"></div>
          </div>
        </div>
        <div (click)="viewType = 'accessibility'"
             class="h-[41px] w-[23px] group-hover:w-[150px] transition-all duration-500 ease-linear flex items-center bg-secondary-500  -ml-2 -z-[2]">
          <span class="overflow-hidden ps-3 pe-2 py-1 hidden group-hover:inline-block text-primary-500 font-semibold">
            {{ "Accessibility"|concat|translate }}</span>
        </div>
      </div>
    } @else {
      <div
        class="flex items-center group opacity-45">
        <div class="helpUtility tw-relative tw-overflow-visible">
          <mat-icon svgIcon="accessibility"></mat-icon>
          <div class="orbit-container">
            <div class="star"></div>
          </div>
        </div>
        <div
          class="h-[41px] w-[23px] transition-all duration-500 ease-linear flex items-center bg-secondary-500  -ml-2 -z-[2]">
          <span class="overflow-hidden ps-3 pe-2 py-1 hidden group-hover:inline-block text-primary-500 font-semibold">
            {{ "Accessibility"|concat|translate }}</span>
        </div>
      </div>
    }

    @if (viewType === undefined || viewType === 'msaadaAi') {
      <div class="flex items-center group">
        <div class="rounded-full border-2 p-[5px] bg-white text-primary-500 border-primary-500 cursor-pointer"
             (click)="viewType = 'msaadaAi'">
          <img alt="Msaada ai" src="assets/images/hudumaAI.png" class="rounded-full animate-bounce  h-12 w-12"
               style="--order-25">
        </div>
        <div (click)="viewType = 'msaadaAi'"
             class="h-[41px] w-[23px] group-hover:w-[150px] transition-all duration-500 ease-linear flex items-center bg-secondary-500  -ml-2 -z-[2]">
          <span
            class="overflow-hidden ps-3 pe-2 py-1 hidden group-hover:inline-block text-primary-500 font-semibold">{{ "Msaada Ai"|concat|translate }}</span>
        </div>
      </div>
    } @else {
      <div class="flex items-center group opacity-45">
        <div class="rounded-full border-2 p-[5px] bg-white text-primary-500 border-primary-500 cursor-pointer">
          <img alt="Msaada ai" src="assets/images/hudumaAI.png" class="rounded-full animate-bounce  h-12 w-12"
               style="--order-25">
        </div>
        <div class="h-[41px] w-[23px] duration-500 ease-linear flex items-center bg-secondary-500  -ml-2 -z-[2]">
          <span
            class="overflow-hidden ps-3 pe-2 py-1 hidden group-hover:inline-block text-primary-500 font-semibold">{{ "Msaada Ai"|concat|translate }}</span>
        </div>
      </div>
    }


    @if (viewType === undefined || viewType === 'chatCenter') {
      <div class="flex items-center group">
        <div
          (click)="viewType = 'chatCenter'"
          class="helpUtility tw-relative tw-overflow-visible">
          <mat-icon svgIcon="bot"></mat-icon>
          <div class="orbit-container">
            <div class="star"></div>
          </div>
        </div>
        <div
          (click)="viewType = 'chatCenter'"
          class="h-[41px] w-[23px] group-hover:w-[150px] transition-all duration-500 ease-linear flex items-center bg-secondary-500  -ml-2 -z-[2]">
          <span
            class="overflow-hidden ps-3 pe-2 py-1 hidden group-hover:inline-block text-primary-500 font-semibold">{{ "Chat center"|concat|translate }}</span>
        </div>
      </div>
    } @else {
      <div class="flex items-center group opacity-45">
        <div class="helpUtility tw-relative tw-overflow-visible">
          <mat-icon svgIcon="bot"></mat-icon>
          <div class="orbit-container">
            <div class="star"></div>
          </div>
        </div>
        <div
          class="h-[41px] w-[23px] group-hover:w-[150px] transition-all duration-500 ease-linear flex items-center bg-secondary-500  -ml-2 -z-[2]">
          <span
            class="overflow-hidden ps-3 pe-2 py-1 hidden group-hover:inline-block text-primary-500 font-semibold">{{ "Chat center"|concat|translate }}</span>
        </div>
      </div>
    }


    @if (viewType === undefined || viewType === 'newsUpdate') {
      <div class="flex items-center group">
        <div
          class="helpUtility tw-relative tw-overflow-visible">
          <mat-icon>newspaper</mat-icon>
          <div class="orbit-container">
            <div class="star"></div>
          </div>
        </div>
        <div
          class="h-[41px] w-[23px] group-hover:w-[150px] transition-all duration-500 ease-linear flex items-center bg-secondary-500  -ml-2 -z-[2]">
          <span
            class="overflow-hidden ps-3 pe-2 py-1 hidden group-hover:inline-block text-primary-500 font-semibold">{{ "News & Update"|concat|translate }}</span>
        </div>
      </div>
    } @else {
      <div class="flex items-center group opacity-45">
        <div class="helpUtility tw-relative tw-overflow-visible">
          <mat-icon>newspaper</mat-icon>
          <div class="orbit-container">
            <div class="star"></div>
          </div>
        </div>
        <div
          class="h-[41px] w-[23px] group-hover:w-[150px] transition-all duration-500 ease-linear flex items-center bg-secondary-500  -ml-2 -z-[2]">
          <span
            class="overflow-hidden ps-3 pe-2 py-1 hidden group-hover:inline-block text-primary-500 font-semibold">{{ "News & Update"|concat|translate }}</span>
        </div>
      </div>
    }

  </div>
</div>
